import * as React from "react";
import { FieldProps } from "formik";
import Dropzone from "react-dropzone";

export const DropzoneField: React.SFC<FieldProps<any>> = ({
  field: { name },
  form: { setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <Dropzone
      multiple={false}
      accept="image/jpeg, image/png"
      // tslint:disable-next-line
      onDrop={([file]) => {
        setFieldValue(name, file);
      }}
      {...props}
      style={{
        width: 250,
        height: 130,
        borderWidth: 2,
        borderColor: "#666",
        borderStyle: "dashed",
        borderRadius: 5
      }}
    >
      <p>
        Try dropping some files here, or click to select files to upload. (max
        size 5mb)
      </p>
    </Dropzone>
  );
};

// const file = (origFile: any) => {
//   const MAX_WIDTH = 800;
//   const MAX_HEIGHT = 600;

//   const reader = new FileReader();

//   // Convert file to img

//   reader.addEventListener("load", event => {
//     const origImg = new Image();
//     origImg.src = event.target.result;

//     origImg.addEventListener("load", event => {
//       let width = event.target.width;
//       let height = event.target.height;

//       // Don't resize if it's small enough

//       if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
//         return origFile;
//       }
//       // Calc new dims otherwise
//       if (width > height) {
//         if (width > MAX_WIDTH) {
//           height *= MAX_WIDTH / width;
//           width = MAX_WIDTH;
//         }
//       } else {
//         if (height > MAX_HEIGHT) {
//           width *= MAX_HEIGHT / height;
//           height = MAX_HEIGHT;
//         }
//       }

//       // Resize
//       const canvas = document.createElement("canvas");
//       canvas.width = width;
//       canvas.height = height;

//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(origImg, 0, 0, width, height);

//       return base64ToFile(canvas.toDataURL(), origFile);
//     });
//   });

//   reader.readAsDataURL(origFile);
// };



// WEBPACK FOOTER //
// ./src/util/DropzoneField.tsx